import PageLayout from '../components/page-layout';

<template>
  <PageLayout>
    <:content>
      <div class="pds-witsmlstudio-backdrop" />
    </:content>
  </PageLayout>
</template>
